import * as React from 'react';
import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'rgba(0, 0, 0, .03)',
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    marginLeft: theme.spacing(1),
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: theme.spacing(2),
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default function Accordions() {
  const { t } = useTranslation()
  const [expanded, setExpanded] = React.useState('panel1');

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false);
  };

  return (
    <div>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" style={{ backgroundColor: "rgba(0, 0, 0, 0.3)", gap: 20 }} >
          <Typography style={{ color: "#FFF", fontWeight: "bold", fontSize: '1.5rem' }} >
            {t('home.SerciceOne')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ fontSize: '1.5rem' }}>
          {/* <Typography variant='h5' >
            {t('home.SerciceOneDesk')}
          </Typography> */}
          <ol type='A'>
            <li>{t('home.SerciceOneDeskA')}</li>
            <li>{t('home.SerciceOneDeskB')}</li>
            <li>{t('home.SerciceOneDeskC')}</li>
            <li>{t('home.SerciceOneDeskD')}</li>
            <li>{t('home.SerciceOneDeskE')}</li>
            <li>{t('home.SerciceOneDeskF')}</li>
          </ol>
        </AccordionDetails>
      </Accordion>
      <Accordion expanded={expanded === 'panel2'} onChange={handleChange('panel2')} >
        <AccordionSummary aria-controls="panel2d-content" id="panel2d-header" style={{ backgroundColor: "rgba(0, 0, 0, 0.3)", gap: 20 }}>
          <Typography style={{ color: "#FFF", fontWeight: "bold", fontSize: '1.5rem' }}>
            {t('home.SerciceTow')}
          </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ fontSize: '1.5rem' }}>
          {/* <Typography variant='h5' >
            {t('home.SerciceTowDesk')}
          </Typography> */}
          <ol type='A'>
            <li>{t('home.SerciceTowDeskA')}</li>
            <li>{t('home.SerciceTowDeskB')}</li>
            <li>{t('home.SerciceTowDeskC')}</li>
            <li>{t('home.SerciceTowDeskD')}</li>
          </ol>
        </AccordionDetails>
      </Accordion>
    </div>
  );
}